module.exports = __webpack_public_path__ + "static/media/tlyfeImageText1.f5cc1fad.png";